



import React, { useContext, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { MyContext } from "../../App";
import { Link } from "react-router-dom";
import { emphasize, styled } from "@mui/material/styles";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Chip from "@mui/material/Chip";
import HomeIcon from "@mui/icons-material/Home";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { IoCloseSharp } from "react-icons/io5";
import { FaEdit, FaEye } from "react-icons/fa";
import { deleteData, fetchDataFromApi } from "../../utils/api";
import * as MuiIcons from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
});

const SubCategory = () => {
  const [catData, setCatData] = useState([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteName, setDeleteName] = useState("");
  const [viewDetailsDialog, setViewDetailsDialog] = useState(false);
  const [selectedSubCat, setSelectedSubCat] = useState(null);

  const context = useContext(MyContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    context.setProgress(20);
    fetchDataFromApi("/api/category").then((res) => {
      setCatData(res);
      context.setProgress(100);
    });
  }, []);

  const getIconComponent = (iconName) => {
    const IconComponent = MuiIcons[iconName];
    return IconComponent ? <IconComponent style={{ fontSize: "16px" }} /> : null;
  };

  const deleteSubCat = (id) => {
    const userInfo = JSON.parse(localStorage.getItem("user"));
    if (userInfo?.email === "rismicmartpvtltd@gmail.com") {
      context.setProgress(30);
      deleteData(`/api/category/${id}`).then((res) => {
        context.setProgress(100);
        fetchDataFromApi("/api/category").then((res) => {
          setCatData(res);
          context.setProgress(100);
          context.setAlertBox({
            open: true,
            error: false,
            msg: "Sub Category Deleted!",
          });
        });
      });
    } else {
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Only Admin can delete Sub Category",
      });
    }
  };

  const handleOpenConfirm = (id, name) => {
    setDeleteId(id);
    setDeleteName(name || "");
    setConfirmOpen(true);
  };

  const handleCloseConfirm = () => {
    setConfirmOpen(false);
    setDeleteId(null);
    setDeleteName("");
  };

  const handleConfirmDelete = () => {
    if (deleteId) {
      deleteSubCat(deleteId);
    }
    handleCloseConfirm();
  };

  const handleOpenDetails = (subCat) => {
    setSelectedSubCat(subCat);
    setViewDetailsDialog(true);
  };

  const handleCloseDetails = () => {
    setViewDetailsDialog(false);
    setSelectedSubCat(null);
  };

  return (
    <>
      <div className="right-content w-100">
        <div className="card shadow border-0 w-100 flex-row p-4 align-items-center">
          <h5 className="mb-0">Sub Category List</h5>

          <div className="ml-auto d-flex align-items-center">
            <Breadcrumbs
              aria-label="breadcrumb"
              className="ml-auto breadcrumbs_"
            >
              <StyledBreadcrumb
                component="a"
                href="#"
                label="Dashboard"
                icon={<HomeIcon fontSize="small" />}
              />

              <StyledBreadcrumb
                label="Sub Category"
                deleteIcon={<ExpandMoreIcon />}
              />
            </Breadcrumbs>

            <Link to="/subCategory/add">
              <Button className="btn-blue ml-3 pl-3 pr-3">
                Add Sub Category
              </Button>
            </Link>
          </div>
        </div>

        <div className="card shadow border-0 p-3 mt-4">
          <div className="table-responsive mt-3">
            <table className="table table-bordered table-striped v-align">
              <thead className="thead-dark">
                <tr>
                  <th style={{ width: "100px" }}>CATEGORY IMAGE</th>
                  <th>CATEGORY</th>
                  <th>SUB CATEGORIES</th>
                </tr>
              </thead>

              <tbody>
                {catData?.categoryList?.length !== 0 &&
                  catData?.categoryList?.map((item, index) => {
                    if (item?.children?.length !== 0) {
                      return (
                        <tr key={index}>
                          <td>
                            <div
                              className="d-flex align-items-center"
                              style={{ width: "150px" }}
                            >
                              <div
                                className="imgWrapper"
                                style={{ width: "50px", flex: "0 0 50px" }}
                              >
                                <div className="img card shadow m-0">
                                  {item?.images?.length > 0 ? (
                                    <LazyLoadImage
                                      alt={"image"}
                                      effect="blur"
                                      className="w-100"
                                      src={item.images[0]}
                                    />
                                  ) : (
                                    <div
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        background: "#f0f0f0",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "8px",
                                      }}
                                    >
                                      No Image
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              {item?.icon && (
                                <div
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "8px",
                                    background: item?.color || "#f5f5f5",
                                    borderRadius: "6px",
                                    marginRight: "10px",
                                  }}
                                >
                                  {getIconComponent(item.icon)}
                                </div>
                              )}
                              <span className="text-capitalize">{item.name}</span>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex flex-wrap align-items-center">
                              {item?.children?.length !== 0 &&
                                item?.children?.map((subCat) => {
                                  return (
                                    <div
                                      key={subCat._id}
                                      className="m-1"
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        background: subCat?.color || "#e3f2fd",
                                        borderRadius: "20px",
                                        padding: "6px 12px",
                                        border: "1px solid #ddd",
                                      }}
                                    >
                                      {subCat?.icon && (
                                        <span
                                          style={{
                                            marginRight: "6px",
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          {getIconComponent(subCat.icon)}
                                        </span>
                                      )}
                                      <span
                                        className="text-capitalize"
                                        style={{
                                          fontSize: "13px",
                                          fontWeight: "500",
                                        }}
                                      >
                                        {subCat.name}
                                      </span>
                                      
                                      <Tooltip title="View Details">
                                        <FaEye
                                          className="cursor ml-2"
                                          style={{
                                            fontSize: "14px",
                                            color: "#2196f3",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => handleOpenDetails(subCat)}
                                        />
                                      </Tooltip>

                                      <Tooltip title="Edit">
                                        <Link to={`/subCategory/edit/${subCat._id}`}>
                                          <FaEdit
                                            className="cursor ml-2"
                                            style={{
                                              fontSize: "14px",
                                              color: "#ff9800",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </Link>
                                      </Tooltip>

                                      <Tooltip title="Delete">
                                        <IoCloseSharp
                                          className="cursor ml-2"
                                          style={{
                                            fontSize: "18px",
                                            color: "#f44336",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            handleOpenConfirm(
                                              subCat._id,
                                              subCat.name
                                            )
                                          }
                                        />
                                      </Tooltip>
                                    </div>
                                  );
                                })}
                            </div>
                          </td>
                        </tr>
                      );
                    }
                    return null;
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Confirmation Dialog for Sub Category deletion */}
      <Dialog open={confirmOpen} onClose={handleCloseConfirm}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the sub-category{" "}
            <strong>{deleteName}</strong>?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirm} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Details Dialog */}
      <Dialog
        open={viewDetailsDialog}
        onClose={handleCloseDetails}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Sub Category Details: {selectedSubCat?.name}
        </DialogTitle>
        <DialogContent>
          {selectedSubCat && (
            <div className="subcat-details">
              <div className="row mb-3">
                <div className="col-md-6">
                  <strong>Sub Category Name:</strong>
                  <p className="text-capitalize">{selectedSubCat?.name}</p>
                </div>
                <div className="col-md-6">
                  <strong>Slug:</strong>
                  <p>{selectedSubCat?.slug || "N/A"}</p>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <strong>Card Color:</strong>
                  <div className="d-flex align-items-center mt-2">
                    <div
                      style={{
                        width: "60px",
                        height: "40px",
                        background: selectedSubCat?.color || "#ffffff",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        marginRight: "10px",
                      }}
                    ></div>
                    <small>{selectedSubCat?.color || "None"}</small>
                  </div>
                </div>
                <div className="col-md-6">
                  <strong>Theme Color:</strong>
                  <div className="d-flex align-items-center mt-2">
                    <div
                      style={{
                        width: "60px",
                        height: "40px",
                        background: selectedSubCat?.themeColor || "#ffffff",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        marginRight: "10px",
                      }}
                    ></div>
                    <small>{selectedSubCat?.themeColor || "None"}</small>
                  </div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-12">
                  <strong>Icon:</strong>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      padding: "10px 15px",
                      background: selectedSubCat?.color || "#f5f5f5",
                      borderRadius: "8px",
                      marginTop: "10px",
                    }}
                  >
                    {selectedSubCat?.icon ? (
                      <>
                        <span style={{ fontSize: "24px", marginRight: "10px" }}>
                          {getIconComponent(selectedSubCat.icon)}
                        </span>
                        <span>{selectedSubCat.icon}</span>
                      </>
                    ) : (
                      <span>No Icon</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-12">
                  <strong>Thumbnail Images:</strong>
                  <div className="d-flex flex-wrap mt-2">
                    {selectedSubCat?.images?.length > 0 ? (
                      selectedSubCat.images.map((img, idx) => (
                        <div
                          key={idx}
                          className="m-2"
                          style={{ width: "100px" }}
                        >
                          <LazyLoadImage
                            alt={`thumbnail-${idx}`}
                            effect="blur"
                            src={img}
                            style={{
                              width: "100%",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "8px",
                              border: "2px solid #ddd",
                            }}
                          />
                        </div>
                      ))
                    ) : (
                      <p className="text-muted">No thumbnail images</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-12">
                  <strong>Banner Images:</strong>
                  <div className="d-flex flex-wrap mt-2">
                    {selectedSubCat?.bannerImages?.length > 0 ? (
                      selectedSubCat.bannerImages.map((img, idx) => (
                        <div
                          key={idx}
                          className="m-2"
                          style={{ width: "150px" }}
                        >
                          <LazyLoadImage
                            alt={`banner-${idx}`}
                            effect="blur"
                            src={img}
                            style={{
                              width: "100%",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "8px",
                              border: "2px solid #ddd",
                            }}
                          />
                        </div>
                      ))
                    ) : (
                      <p className="text-muted">No banner images</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-12">
                  <strong>Banner Videos:</strong>
                  <div className="d-flex flex-wrap mt-2">
                    {selectedSubCat?.bannerVideos?.length > 0 ? (
                      selectedSubCat.bannerVideos.map((vid, idx) => (
                        <div
                          key={idx}
                          className="m-2"
                          style={{ width: "250px" }}
                        >
                          <video
                            controls
                            style={{
                              width: "100%",
                              height: "150px",
                              borderRadius: "8px",
                              border: "2px solid #ddd",
                            }}
                            src={vid}
                          />
                        </div>
                      ))
                    ) : (
                      <p className="text-muted">No banner videos</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDetails} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SubCategory;

